/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-06-20 09:41:35
 * @LastEditors: hongye
 * @LastEditTime: 2025-08-28 13:50:30
 */
/**名称和URL关联枚举 */
enum UnionEnum {
  /**首页 */
  HOME,
  /**无权限 */
  NOAUTH,
  /**登录 */
  LOGIN,
  // 忘记密码
  FORGETPWD,
  /** 包裹管理 */
  PACKMANAGE,
  /** COD统计 */
  CODSTATISTICS,
  /** 异常支付审核 */
  ABNORMALPAYMENT,
  /** 派件包裹列表 */
  DISPATCHLIST,
  /**notFound */
  NOTFOUND,
  /**运营管理 */
  SITEMANAGER,
  /**站点列表 */
  SITELIST,
  /**入驻审核 */
  REVIEWLIST,
  /**驿站员工管理 */
  STAFFMANAGER,
  /**管理中心 */
  MANAGECENTER,
  /** 公告列表 */
  ANNOUNCEMENTLIST,
  /** 问题反馈 */
  FEEDBACK,
  /** 运营账号管理 */
  OPERATEACCOUNTMANAGE,
  /** 角色管理 */
  ROLEMANAGE,
  /** 菜单管理 */
  MENUMANAGE,
  /** 数据字典 */
  DATADICTIONARY,
  /** 代理区维护 */
  AGENCYAREALIST,
  /** 快递公司维护 */
  EXPRESSCOMPANYMANAGE,
  /**短信管理*/
  SMSMANAGE,
  /**短信记录*/
  SMSRECORD,
  /**短信模板*/
  SMSTEMPLATE,
  /** I18n */
  I18N,
  /** YoYi客户管理 */
  CUSTOMERMANAGEMENT,
  /** 寄件列表*/
  SHIPPINGLIST,
  // 账户管理
  ACCOUNT_MANAGEMENT,
  // COD账户管理
  COD_ACCOUNT_MANAGEMENT,
  // 预付款管理
  ADVANCE_MANAGEMENT,
  // COD预付款管理
  COD_ADVANCE_MANAGEMENT,
  /** 预付款审核列表 */
  AUDIT_MANAGEMENT,
  /** COD预付款审核列表 */
  COD_AUDIT_MANAGEMENT,
  /**预付款查询*/
  ADVANCE_INQUIRY,
  /**COD预付款查询*/
  COD_ADVANCE_INQUIRY,
  /** 扣款失败查询 */
  FAILURE_MANAGEMENT,
  /** COD扣款失败查询 */
  COD_FAILURE_MANAGEMENT,
  /**预付款费用类型*/
  FEE_TYPE_MANAGEMENT,
  /** COD预付款费用类型 */
  COD_FEE_TYPE_MANAGEMENT
}

/**name 枚举 */
enum NameEnum {
  首页 = UnionEnum.HOME,
  无权限 = UnionEnum.NOAUTH,
  登录 = UnionEnum.LOGIN,
  忘记密码 = UnionEnum.FORGETPWD,
  COD统计 = UnionEnum.CODSTATISTICS,
  异常支付审核 = UnionEnum.ABNORMALPAYMENT,
  包裹管理 = UnionEnum.PACKMANAGE,
  派件包裹列表 = UnionEnum.DISPATCHLIST,
  运营管理 = UnionEnum.SITEMANAGER,
  站点列表 = UnionEnum.SITELIST,
  入驻审核 = UnionEnum.REVIEWLIST,
  驿站员工管理 = UnionEnum.STAFFMANAGER,
  管理中心 = UnionEnum.MANAGECENTER,
  公告列表 = UnionEnum.ANNOUNCEMENTLIST,
  问题反馈 = UnionEnum.FEEDBACK,
  运营账号管理 = UnionEnum.OPERATEACCOUNTMANAGE,
  角色管理 = UnionEnum.ROLEMANAGE,
  菜单管理 = UnionEnum.MENUMANAGE,
  数据字典 = UnionEnum.DATADICTIONARY,
  代理区维护 = UnionEnum.AGENCYAREALIST,
  快递公司维护 = UnionEnum.EXPRESSCOMPANYMANAGE,
  短信管理 = UnionEnum.SMSMANAGE,
  短信记录 = UnionEnum.SMSRECORD,
  短信模板 = UnionEnum.SMSTEMPLATE,
  i18n = UnionEnum.I18N,
  YoYi客户管理 = UnionEnum.CUSTOMERMANAGEMENT,
  寄件包裹列表 = UnionEnum.SHIPPINGLIST,
  账户管理 = UnionEnum.ACCOUNT_MANAGEMENT,
  COD账户管理 = UnionEnum.COD_ACCOUNT_MANAGEMENT,
  预付款管理 = UnionEnum.ADVANCE_MANAGEMENT,
  COD预付款管理 = UnionEnum.COD_ADVANCE_MANAGEMENT,
  预付款审核列表 = UnionEnum.AUDIT_MANAGEMENT,
  COD预付款审核列表 = UnionEnum.COD_AUDIT_MANAGEMENT,
  预付款查询 = UnionEnum.ADVANCE_INQUIRY,
  COD预付款查询 = UnionEnum.COD_ADVANCE_INQUIRY,
  扣款失败查询 = UnionEnum.FAILURE_MANAGEMENT,
  COD扣款失败查询 = UnionEnum.COD_FAILURE_MANAGEMENT,
  预付款费用类型 = UnionEnum.FEE_TYPE_MANAGEMENT,
  COD预付款费用类型 = UnionEnum.COD_FEE_TYPE_MANAGEMENT
}
/**Url 枚举 */
enum UrlEnum {
  '/' = UnionEnum.HOME,
  '/noAuth' = UnionEnum.NOAUTH,
  '/login' = UnionEnum.LOGIN,
  '/forgetPwd' = UnionEnum.FORGETPWD,
  '/notFound' = UnionEnum.NOTFOUND,
  '/codPaymentBoard' = UnionEnum.CODSTATISTICS,
  /** 异常支付审核 */
  '/abnormalPayment' = UnionEnum.ABNORMALPAYMENT,
  '/dispatchList' = UnionEnum.DISPATCHLIST,
  '/siteList' = UnionEnum.SITELIST,
  '/reviewList' = UnionEnum.REVIEWLIST,
  '/staffManager' = UnionEnum.STAFFMANAGER,
  '/announcementList' = UnionEnum.ANNOUNCEMENTLIST,
  '/feedback' = UnionEnum.FEEDBACK,
  '/operateAccountManage' = UnionEnum.OPERATEACCOUNTMANAGE,
  '/roleManage' = UnionEnum.ROLEMANAGE,
  '/menuManage' = UnionEnum.MENUMANAGE,
  '/dataDictionary' = UnionEnum.DATADICTIONARY,
  '/agencyAreaList' = UnionEnum.AGENCYAREALIST,
  '/expressCompanyManage' = UnionEnum.EXPRESSCOMPANYMANAGE,
  '/sms/smsRecord' = UnionEnum.SMSRECORD,
  '/sms/smsTemplate' = UnionEnum.SMSTEMPLATE,
  '/i18n' = UnionEnum.I18N,
  '/customerManagement' = UnionEnum.CUSTOMERMANAGEMENT,
  '/shippingList' = UnionEnum.SHIPPINGLIST,
  '/accountManagement' = UnionEnum.ACCOUNT_MANAGEMENT,
  '/codAccountManagement' = UnionEnum.COD_ACCOUNT_MANAGEMENT,
  '/advanceManagement' = UnionEnum.ADVANCE_MANAGEMENT,
  '/codAdvanceManagement' = UnionEnum.COD_ADVANCE_MANAGEMENT,
  '/auditManagement' = UnionEnum.AUDIT_MANAGEMENT,
  '/codAuditManagement' = UnionEnum.COD_AUDIT_MANAGEMENT,
  '/advanceInquiry' = UnionEnum.ADVANCE_INQUIRY,
  '/codAdvanceInquiry' = UnionEnum.COD_ADVANCE_INQUIRY,
  '/failureManagement' = UnionEnum.FAILURE_MANAGEMENT,
  '/codFailureManagement' = UnionEnum.COD_FAILURE_MANAGEMENT,
  '/feeTypeManagement' = UnionEnum.FEE_TYPE_MANAGEMENT,
  '/codFeeTypeManagement' = UnionEnum.COD_FEE_TYPE_MANAGEMENT
}
export { NameEnum, UrlEnum, UnionEnum }
